import { utils } from '@atlaskit/util-service-support';
import { SimpleCache } from '../../../utils/simple-cache';
import { timed } from '../timing';
export class CollaborationGraph {
  async makeRequest(path, body) {
    const options = {
      path,
      requestInit: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(body)
      }
    };
    return timed(utils.requestService(this.serviceConfig, options));
  }
  constructor({
    url
  }) {
    this.serviceConfig = {
      url
    };
    this.getContainersSupplier = this.getContainersSupplier.bind(this);
    this.getUsersSupplier = this.getUsersSupplier.bind(this);
    this.containersCache = new SimpleCache(this.getContainersSupplier);
    this.usersCache = new SimpleCache(this.getUsersSupplier);
  }
}